module.exports = __webpack_public_path__ + "static/media/art74.f3230989.jpg";